<template>
<div class="reviewItem">
  <div class = "rev">
    <div class="userInfo">
      <div class="name">{{params.name}}</div>
      <div class="date">{{params.date}}</div>
      <div class="rating">
        <span v-for="r in (params.rating*1)">★</span>
      </div>
    </div>
    <div class="review">{{params.text}}</div>
  </div>
  <div class = "answ" v-if="params.answer">
    <div class="userInfo">
      <div class="name">TOUS</div>
      <div class="date">{{ params.answer_date }}</div>
    </div>
    <div class="review">{{params.answer}}</div>
  </div>
</div>
</template>

<script>
export default {
  name: "shop_reviews_item",
  selector: '.shop_reviews_item',
  props:{params: Object},
}
</script>

<style scoped>
.reviewItem
{
  border-bottom: solid 1px #aaa;
  padding-bottom: 5px;
  margin-bottom: 15px;
}
.rev,
.answ
{
  display: flex;
}
.userInfo {
  min-width: 200px;
}
.userInfo .name
{
  color: #000;
}
.userInfo .date
{
  color: #8c8b84;
  text-transform: lowercase;
}
.userInfo .rating {
  color: #eec7c3;
}
.answ
{
  margin-left: 50px;
  border-top: solid 1px #aaa;
  margin-top: 15px;
  padding-top: 5px;
}
@media (max-width: 600px) {
  .rev, .answ {
    flex-wrap: wrap;
  }
  .userInfo {
    width: 100%;
  }
}
</style>